module.exports = __webpack_public_path__ + "img/hongshanxia1.88328c60.png";